import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './Core/Layout/layout.component';
import { HttpClientModule } from '@angular/common/http';
import { LiteralConstant } from './Core/constants';
import { GenderComponent } from './Components/Questions/gender/gender.component';
import { FormsModule } from '@angular/forms';
import { PrimaryDobComponent } from './Components/Questions/primary-dob/primary-dob.component';
import { PostalCodeComponent } from './Components/Questions/postal-code/postal-code.component';
import { TelephoneComponent } from './Components/Questions/telephone/telephone.component';
import { EmailComponent } from './Components/Questions/email/email.component';
import { PrivacyPolicyComponent } from './components/common/privacy-policy/privacy-policy.component';
import { AdditionalInsurersComponent } from './components/questions/additional-insurers/additional-insurers.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ProgressComponent } from './components/progress/progress.component';
import { QuoteEmailLandingComponent } from './components/email-landing/quote-email-landing/quote-email-landing.component';
import { LoadingComponent } from './components/email-landing/loading/loading.component'
import { DatePipe } from '@angular/common'
import { RasAyudaModule } from 'ras-ayuda';
import { RasGtmModule, RasGtmService } from 'ras-gtm';
import { CookieBarModule, CookieBarService } from 'ras-cookie-bar';
import { ScriptLoaderService, UtilModule, StylesheetLoaderService } from 'ras-util';
import { SessionExpiryComponent } from './components/session-expiry/session-expiry.component';
import { ReCaptchaV3Component } from './components/captcha-v3/captcha-v3.component';
import { UpaPluginsComponent } from './Core/UPA/upa-plugins/upa-plugins.component';
import { ConfigurationService } from './configuration.service';
import { RedirectorGuard } from './Core/redirector-guard/redirector-guard';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    GenderComponent,
    PrimaryDobComponent,
    PostalCodeComponent,
    TelephoneComponent,
    EmailComponent,
    PrivacyPolicyComponent,
    AdditionalInsurersComponent,
    ProgressComponent,
    QuoteEmailLandingComponent,
    LoadingComponent,
    ReCaptchaV3Component,
    SessionExpiryComponent,
    UpaPluginsComponent
  ],
  imports: [
    NgxMaskModule.forRoot(),
    FormsModule,
    BrowserModule,
    HttpClientModule,
    UtilModule,
    AppRoutingModule,
    RasAyudaModule,
    RasGtmModule,
    CookieBarModule,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{
    provide: LiteralConstant.API_URL,
    useFactory: getBaseUrl
  }, DatePipe, RasGtmService, CookieBarService, ScriptLoaderService, StylesheetLoaderService,
    RedirectorGuard,
    ConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: configurationServiceFactory,
      deps: [ConfigurationService],
      multi: true
    }
],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function getBaseUrl() {
  return window.location.origin + '/';
}
export function configurationServiceFactory(appConfigService: ConfigurationService) {
  return () => appConfigService.loadConfigurationData();
}
